/**
 * Ortam ayarları tek yerde toplanır; `import.meta.env` başka hiçbir dosyada okunmaz.
 */
const raw = import.meta.env

export const env = {
  /** Tek origin hedefli göreli taban yol. Prod'da nginx, dev'de Vite proxy karşılar. */
  apiBaseUrl: raw.VITE_API_BASE_URL ?? '/api/v1',
  isDev: raw.DEV,
} as const
